module.exports = __webpack_public_path__ + "assets/gmail.35457ccc.svg";